import * as THREE from 'three';
import Experience from './Experience';

export default class Renderer
{
    constructor()
    {
        this.experience = new Experience();
        this.sizes = this.experience.sizes;
        this.quality = this.experience.quality;
        this.scene = this.experience.scene;
        this.canvas = this.experience.canvas;
        this.camera = this.experience.camera;

        // レンダラーの設定
        this.setInstance();
    }

    setInstance()
    {
        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            alpha : false, // 背景を透明にする
        });
        // TODO: レンダラーの設定を調整
        this.instance.toneMapping = THREE.CineonToneMapping;   // トーンマッピングをCineonに設定().るさやコントラストが強調され、シネマティックな見た目
        this.instance.toneMappingExposure = 1.75;              // トーンマッピングの露出を調整
        this.instance.shadowMap.enabled = true;                // シャドウマップを有効。シーン内のオブジェクトが影を落とすことができるようにする
        this.instance.shadowMap.type = THREE.PCFSoftShadowMap; // ソフトシャドウを有効にする
        this.instance.setClearColor(0x000011, 1.0);                // 背景色を設定
        this.instance.setSize(this.sizes.width, this.sizes.height);
        // 低スペック端末では pixelRatio を抑えてフレームレートを優先する
        this.instance.setPixelRatio(Math.min(this.sizes.pixelRatio, this.quality.maxPixelRatio));
      }

    resize()
    {
        this.instance.setSize(this.sizes.width, this.sizes.height);
        this.instance.setPixelRatio(Math.min(this.sizes.pixelRatio, this.quality.maxPixelRatio));
    }

    update()
    {
        // マイフレーム、シーンを再描画(再度レンダリング)
        this.instance.render(this.scene, this.camera.instance);
    }
}